// eslint-disable-next-line no-shadow
export enum RolesEnum {
  ADMINISTRADOR = 'administrador',
  TECNICO = 'técnico',
  GERENTE_CONTAS = 'gerente de contas',
  PARCEIRO_COMERCIAL = 'parceiro comercial',
  CLIENTE = 'cliente',
  OPERACIONAL = 'operacional',
  SUPORTE = 'suporte',
  CLIENTE_MASTER = 'cliente master',
}
